import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "../Response/responseSlice";
import { setToast, setLoading, setModal } from "../uiSlice";
import { createPermiso, getPermisoRol, getPermisos, delPermiso, createOpcion } from "../../Services/permisos_service";
import { filterTwoArrays } from "../../Services/functions_service";

const initialState = {
    permisos: [],
    permisosSeleccionados: [],
    permisosAsignados: [],
    permisosUsuario: [],
    permiso: {
        idOpcion: 0,
        nombre: "",
        etiqueta: "",
        modulo: null,
        estado: 1,
        descripcion: "",
        icono: "",
        orden: 0,
        movil: false,
        mostrarMenu: true,
        idOptPadre: null,
        idSegmento: null,
    },
}

export const permisoSlice = createSlice({
    name: 'permisos',
    initialState,
    reducers: {
        setPermisos: (state, action) => {
            state.permisos = action.payload;
        },
        setPermisosAsignados: (state, action) => {
            state.permisosAsignados = action.payload;
        },
        setPermisosSeleccionados: (state, action) => {
            state.permisosSeleccionados = action.payload;
        },
        updatePermisoField: (state, action) => {
            const { name, value } = action.payload;
            state.permiso[name] = value;
        },
        setPermisosUsuario: (state, action) => {
            state.permisosUsuario = action.payload;
        },
        setPermiso: (state, action) => {
            state.permiso = action.payload;
        },
        resetPermisos: () => initialState,
    }
});

export const fetchPermisos = createAsyncThunk(
    'permiso/fetchPermisos',
    async (_, { dispatch }) => {
        dispatch(setLoading(true))
        const permisosRes = await getPermisos();
        dispatch(setPermisos(permisosRes));
        dispatch(setLoading(false));
    }
);


export const fetchPermisosAsignados = createAsyncThunk(
    'permiso/fetchPermisosAsignados',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const permisosRes = await getPermisos();
        const asignadosRes = await getPermisoRol(data);
        dispatch(setPermisos(asignadosRes ? filterTwoArrays(permisosRes, asignadosRes, "idOpcion") : permisosRes));
        asignadosRes ? dispatch(setPermisosAsignados(asignadosRes.filter(opt => !Object.is(opt.modulo, null)))) : dispatch(setPermisosAsignados(null));
        dispatch(setLoading(false));
    }
);

export const fetchPermisosUsuario = createAsyncThunk(
    'permiso/fetchPermisosUsuario',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const permisosRes = await getPermisos();
        const asignadosRes = await getPermisoRol(data);
        dispatch(setPermisos(asignadosRes ? filterTwoArrays(permisosRes, asignadosRes, "idOpcion") : permisosRes));
        asignadosRes ? dispatch(setPermisosUsuario(asignadosRes.filter(opt => !Object.is(opt.modulo, null)))) : dispatch(setPermisosUsuario(null));
        dispatch(setLoading(false));
    }
);

export const addPermiso = createAsyncThunk(
    'permiso/create',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const permisoRes = await createPermiso(data);
        console.log(permisoRes);
        dispatch(setResponse(permisoRes));
        dispatch(fetchPermisosAsignados(data))
        dispatch(setLoading(false));
        dispatch(setToast(true));
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const deletePermiso = createAsyncThunk(
    'permiso/delete',
    async (data, { dispatch }) => {
        const permisoRes = await delPermiso(data);
        console.log(permisoRes);
        dispatch(setResponse(permisoRes));
        dispatch(setToast(true));
        dispatch(fetchPermisosAsignados(data));
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const mergeOpcion = createAsyncThunk(
    'opcion/merge',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const opcionRes = await createOpcion(data);
        dispatch(setResponse(opcionRes));
        dispatch(fetchPermisos(data));
        dispatch(resetPermisos());
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const { setPermisos, setPermisosAsignados, setPermisosSeleccionados, setPermisosUsuario, setPermiso, updatePermisoField, resetPermisos } = permisoSlice.actions;
export default permisoSlice.reducer;